// extracted by mini-css-extract-plugin
export default {"BalloonBody":"Balloon_BalloonBody__3-PVl","EditIcon":"Balloon_EditIcon__Iy3oy","LabelInBalloon":"Balloon_LabelInBalloon__mWQxK"};